import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Root Beer</title>
                    <meta name="description" content="A&W Root Beer® is made with natural cane sugar and all-natural flavours." />
                </Helmet>
            :
                <Helmet>
                    <title>Notre Root Beer</title>
                    <meta name="description" content="La Root Beer A&W™ est faite avec du sucre de canne naturel et des saveurs naturelles." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;